import { boolean, object, string } from 'yup'

import { REQUIRED_FIELD_MESSAGE } from '@/app/constants/validation'
import {
  DEFAULT_AUTO_MODEL_MAX_LENGTH,
  DEFAULT_AUTO_NUMBER_MAX_LENGTH
} from '@/components/entities/requests/model/constants'
import { MAX_DESCRIPTION_LENGTH } from '@/utils/constants'

export const DEFAULT_AUTO_EMOJI = '🚗'

export type AutoFormData = {
  number: string
  isStandard: boolean
  model: string
  description: string
  emoji: string
}

const trimValue = (value?: string) => value?.trim() ?? ''

export const autoFormSchema = object().shape({
  number: string()
    .transform(trimValue)
    .required(REQUIRED_FIELD_MESSAGE)
    .max(
      DEFAULT_AUTO_NUMBER_MAX_LENGTH,
      `Не более ${DEFAULT_AUTO_NUMBER_MAX_LENGTH} символов`
    ),
  isStandard: boolean().default(true),
  model: string()
    .transform(trimValue)
    .max(
      DEFAULT_AUTO_MODEL_MAX_LENGTH,
      `Не более ${DEFAULT_AUTO_MODEL_MAX_LENGTH} символов`
    )
    .default(''),
  description: string()
    .transform(trimValue)
    .max(MAX_DESCRIPTION_LENGTH, `Не более ${MAX_DESCRIPTION_LENGTH} символов`)
    .default(''),
  emoji: string().required(REQUIRED_FIELD_MESSAGE).default(DEFAULT_AUTO_EMOJI)
})
